import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import intlShape from '@/shared/utils/intlShape';
import YearSelect from '@/shared/components/input/YearSelect';
import OkCancelModal from '@/shared/components/OkCancelModal';
import messages from '../documentMessages';

export default class ChangeReferenceYearModal extends Component {
  state = {
    referenceYear: null,
  };

  static propTypes = {
    show: PropTypes.bool.isRequired,
    intl: intlShape.isRequired,
    onSave: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
  };

  onSave = () => {
    const { referenceYear } = this.state;
    const { onSave } = this.props;
    return onSave({ referenceYear });
  };

  closeModal = () => {
    const { onClose } = this.props;
    onClose();
  };

  render() {
    const { show, intl } = this.props;
    const { referenceYear } = this.state;
    if (!show) return null;

    return (
      <OkCancelModal
        title={intl.formatMessage(messages.ChangeReferenceYear)}
        show={show}
        onClose={this.closeModal}
        disabled={false}
        onSave={() => this.onSave()}
      >
        <div className="form-horizontal">
          <div>
            <div className="form-group">
              <label className="control-label col-md-3">
                <FormattedMessage {...messages.ReferenceYear} />
              </label>
              <div className="col-md-9">
                <YearSelect
                  id="referenceYearField"
                  value={referenceYear}
                  onChange={value => this.setState({ referenceYear: value })}
                />
              </div>
            </div>
          </div>
        </div>
      </OkCancelModal>
    );
  }
}
